import { MAIN_PACE_TASK_IDs } from '@symfa-inc/providence-types';
import { PaceTasksToObjectMapper } from './pace-task-to-object-mapper.interface';
import { PermittingSection } from './workflow-data.interface';

export const PERMITTING_SECTION_MAPPER_OPTIONS: PaceTasksToObjectMapper.Options[] =
  [
    {
      id: MAIN_PACE_TASK_IDs.jurisdictionAuditComplete,
      fieldKey: 'jurisdictionAuditComplete',
    },
    {
      id: MAIN_PACE_TASK_IDs.E911AddressValidation,
      fieldKey: 'e911AddressValidation',
    },
    {
      id: MAIN_PACE_TASK_IDs.prelimCDsReviewedPermitting,
      fieldKey: 'prelimCDsReviewedPermitting',
    },
    {
      id: MAIN_PACE_TASK_IDs.ZBPServicesFormCompleted,
      fieldKey: 'ZBPServicesFormCompleted',
    },
  ];

// synchronize list of workflow/summary pace task dates created via admin (dynamic id)
export const PERMITTING_SECTION_CUSTOM_PACE_TASKS_OPTIONS: {
  taskName: string;
  fieldKey: keyof PermittingSection;
}[] = [
  {
    taskName: 'Final CDs Reviewed - Permitting',
    fieldKey: 'finalCDsReviewedPermitting',
  },
];
